import { DisplayLanguageType } from '@/domain/value_objects/language/displayLanguageType'

export const getCourseHeatMapOptions = (
  categories: string[],
  isLightMode: boolean,
  displayLanguage: DisplayLanguageType
) => {
  return {
    chart: {
      background: isLightMode ? '#ffffff' : '#383838',
      foreColor: isLightMode ? '#00000' : '#EDF2F7',
      height: 400,
      type: 'heatmap',
      toolbar: {
        show: true,
        tools: {
          download: false
        }
      },
      events: {}
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      width: 3,
      colors: [isLightMode ? '#ffffff' : '#383838']
    },
    plotOptions: {
      chart: {
        type: 'heatmap',
        toolbar: {
          show: false,
          tools: {
            download: false,
            selection: false
          }
        },
        zoom: {
          enabled: false
        }
      },
      heatmap: {
        enableShades: false,
        shadeIntensity: 0,
        colorScale: {
          ranges: [
            {
              from: -65535,
              to: -1,
              color: isLightMode ? '#CBD5E0' : '#1e1e1e',
              name: displayLanguage === 'Japanese' ? '該当なし' : 'N/A'
            },
            {
              from: 0,
              to: 0,
              color: isLightMode ? '#ff9d9d' : '#bc6868',
              name: displayLanguage === 'Japanese' ? '未解答' : 'Unanswered'
            },
            {
              from: 1,
              to: 65536,
              color: isLightMode ? '#9BE9A8' : '#689670',
              name: displayLanguage === 'Japanese' ? '解答済み' : 'Answered'
            }
          ]
        }
      }
    },
    grid: {
      xaxis: {
        lines: {
          show: false
        }
      },
      yaxis: {
        lines: {
          show: false
        }
      }
    },
    xaxis: {
      position: 'top',
      categories: categories,
      labels: {
        show: true,
        rotate: 0,
        showDuplicates: false,
        hideOverlappingLabels: true,
        minHeight: 40,
        style: {
          fontSize: '16px',
          colors: isLightMode ? '#000' : '#dfdfdf'
        },
        offsetY: 7
      },
      axisBorder: { show: false },
      axisTicks: {
        show: false
      },
      crosshairs: {
        show: false
      },
      tooltip: {
        enabled: false
      }
    },
    yaxis: {
      labels: {
        show: true,
        style: {
          fontSize: '16px',
          colors: isLightMode ? '#000' : '#dfdfdf'
        }
      },
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      },
      crosshairs: {
        show: false
      }
    },
    states: {
      active: {
        filter: {
          type: 'none'
        }
      },
      hover: {
        filter: {}
      }
    },
    tooltip: {
      enabled: true,
      custom: (opts: {
        ctx: {
          w: {
            config: {
              series: {
                [x: string]: {
                  data: {
                    [x: string]: {
                      [x: string]: any
                      description: any
                    }
                  }
                  name: {
                    [x: string]: {
                      [x: string]: any
                      description: any
                    }
                  }
                }
              }
            }
            globals: {
              labels: {
                [x: string]: {
                  [x: string]: any
                  description: any
                }
              }
            }
          }
        }
        seriesIndex: string | number
        dataPointIndex: string | number
        series: { [x: string]: { [x: string]: any } }
      }) => {
        const desc = opts.ctx.w.config.series[opts.seriesIndex].name
        const count = opts.ctx.w.globals.labels[opts.dataPointIndex]
        let value = ''
        if (opts.series[opts.seriesIndex][opts.dataPointIndex] == 1) {
          value = displayLanguage === 'Japanese' ? '解答済み' : 'Answered'
        } else if (opts.series[opts.seriesIndex][opts.dataPointIndex] == -1) {
          return ''
        } else {
          value = displayLanguage === 'Japanese' ? '未解答' : 'Unanswered'
        }
        return (
          (isLightMode
            ? "<ul style='padding:2px 10px 2px 10px; background-color:#F7F7F7; color:#000; font-size:16px;'><li>"
            : "<ul style='padding:2px 10px 2px 10px; background-color:#1e1e1e; color:#dfdfdf; font-size:16px;'><li>") +
          desc +
          '_' +
          count +
          ': <b>' +
          value
        )
      }
    }
  }
}
